import {
  CARD_STATES,
  CardStates,
  cardText,
  OwlCategoryName,
  OwlRuleName,
  OwlUrl,
  UserInteractionStates,
} from './constants'

import easybib from '@src/styled/theme'
import { CheckType, Replacement } from '@src/types/checks'
import { OwlCategory, OwlRuleCategoryMap } from './types'

export const getCtaText = (type: CheckType, replacements: Replacement[]) => {
  switch (type) {
    case 'plagiarism':
    case 'spellcheck': {
      return cardText[type].cta
    }
    default: {
      // language
      if (replacements && replacements.length > 0) {
        return cardText.languageWithReplacements.cta
      }
      return cardText.language.cta
    }
  }
}

export const getStatusText = (
  type: CheckType,
  cardState: UserInteractionStates,
  replacements: Replacement[]
) => {
  switch (type) {
    case 'plagiarism':
    case 'spellcheck': {
      return cardText[type].status[cardState]
    }
    default: {
      if (replacements && replacements.length > 0) {
        return cardText.languageWithReplacements.status[cardState]
      }
      return cardText.language.status[cardState]
    }
  }
}

// TODO -> move this logic into StyledComponent
//  and out of util.
export const getShadowColors = (cardStatus?: CardStates): string => {
  switch (cardStatus) {
    case CARD_STATES.ACCEPTED:
      return easybib.colors.tealXlight
    case CARD_STATES.REJECTED:
      return easybib.colors.coralXlight
    default:
      return easybib.colors.cheggOrange
  }
}

const owlRuleCategoryMap: OwlRuleCategoryMap[] = [
  {
    owlRules: [
      OwlRuleName.replacement,
      OwlRuleName.deletion,
      OwlRuleName.replacement_with_three_alt_replacements,
      OwlRuleName.replacement_with_alt_replacement,
      OwlRuleName.replacement_with_two_alt_replacements_or_deletion,
      OwlRuleName.replacement_with_two_alt_replacements,
      OwlRuleName.replacement_with_alt_replacement_or_deletion,
      OwlRuleName.his_own,
      OwlRuleName.numerous_different,
      OwlRuleName.and_also,
      OwlRuleName.negate_meaning,
      OwlRuleName.in_terms_of,
      OwlRuleName.time_period_of,
      OwlRuleName.my_personal,
    ],
    owlCategory: {
      category: OwlCategoryName.concision,
      url: OwlUrl.concision,
    },
  },
  {
    owlRules: [OwlRuleName.spellcheck],
    owlCategory: {
      category: OwlCategoryName.spelling,
      url: OwlUrl.spelling,
    },
  },
  {
    owlRules: [OwlRuleName.missing_comma_w_intro_element],
    owlCategory: {
      category: OwlCategoryName.missing_introductory_comma,
      url: OwlUrl.commas_after_intro,
    },
  },
  {
    owlRules: [
      OwlRuleName.verb_form_lf,
      OwlRuleName.he_verb_agr,
      OwlRuleName.have_part_agreement,
      OwlRuleName.been_part_agreement,
    ],
    owlCategory: {
      category: OwlCategoryName.verb_form,
      url: OwlUrl.verb,
    },
  },
  {
    owlRules: [OwlRuleName.sent_frag_lf],
    owlCategory: {
      category: OwlCategoryName.sentence_fragment,
      url: OwlUrl.sentence_fragment,
    },
  },
  {
    owlRules: [OwlRuleName.vague_pronoun_unclear_referent_lf_optional],
    owlCategory: {
      category: OwlCategoryName.vague_reference,
      url: OwlUrl.pronoun,
    },
  },
  {
    owlRules: [OwlRuleName.comma_before_and],
    owlCategory: {
      category: OwlCategoryName.comma_between_clauses,
      url: OwlUrl.commas,
    },
  },
  {
    owlRules: [OwlRuleName.missing_comma_clf],
    owlCategory: {
      category: OwlCategoryName.missing_comma,
      url: OwlUrl.commas,
    },
  },
  {
    owlRules: [
      OwlRuleName.plurals_plural_v2_lf,
      OwlRuleName.plurals_plural_lf,
      OwlRuleName.plurals_singular_lf,
      OwlRuleName.plurals_lf,
      OwlRuleName.a_plural,
    ],
    owlCategory: {
      category: OwlCategoryName.singular_plural,
      url: OwlUrl.plurals,
    },
  },
  {
    owlRules: [
      OwlRuleName.unnecessary_capitalization,
      OwlRuleName.missing_capitalization,
    ],
    owlCategory: {
      category: OwlCategoryName.capitalization,
      url: OwlUrl.capitalization,
    },
  },
  {
    owlRules: [OwlRuleName.serial_comma_on],
    owlCategory: {
      category: OwlCategoryName.serial_comma,
      url: OwlUrl.commas,
    },
  },
  {
    owlRules: [OwlRuleName.unnecessary_comma],
    owlCategory: {
      category: OwlCategoryName.commas,
      url: OwlUrl.commas,
    },
  },
]

export const ruleOwlCategoryMap = new Map<string, OwlCategory>(
  owlRuleCategoryMap.reduce(
    (ruleMapArray, { owlRules, owlCategory }) => [
      ...ruleMapArray,
      ...owlRules.map<[string, OwlCategory]>(rule => [rule.toLowerCase(), owlCategory]),
    ],
    [] // is an array of arrays with key/value pair in array ie [ [rule, category] ]
  )
)
export const truncateTextWithQuotes = (text: string, length: number) => {
  if (text.length <= length) {
    return text
  }

  return `<q>${text.substring(0, length)}...</q>`
}



// WEBPACK FOOTER //
// ./src/components/Cards/utils.ts